import { render } from "./jingongAndweixianjingong.vue?vue&type=template&id=2810aec5&scoped=true"
import script from "./jingongAndweixianjingong.vue?vue&type=script&lang=js"
export * from "./jingongAndweixianjingong.vue?vue&type=script&lang=js"

import "./jingongAndweixianjingong.vue?vue&type=style&index=0&id=2810aec5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2810aec5"]])

export default __exports__